module.exports = __webpack_public_path__ + "img/slid_tit.86a52267.png";